module.exports = __webpack_public_path__ + "img/frame3.cb016d7c.jpg";